<template lang="pug">
  .b-base-table()
    ._header.header
      BaseTableHeaderItem(v-for="header in headersSplit" :key="header.title" :style="setHeaderStyle(header)" v-bind="header" @sort="sortBy")
    ._body.body
      slot(:items="itemsToDisplay" :headers="headersSplit" :sort="sortBy")
        template(v-if="!$scopedSlots.default" )
          template(v-if="itemsFilteredSorted.length")
            ._row(v-for="item in itemsToDisplay" :key="item.id")
              ._cell(v-for="{ header } in headersSplit" :key="header.title" :style="setStyle(header)")
                component(v-if="header.component" :is="header.component.is" v-bind="header.component.props(item)")
          EmptyList(v-else) Нет данных
    BasePagen._pagen(:itemsCount="itemsFilteredSorted.length" :defaultPageSize="pageSize" @paginate="pagen = $event")
</template>

<script>
import BasePagen from '@/components/base/BasePagen.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import EmptyList from '@/components/ui/EmptyList.vue';
import BaseTableHeaderItem from '@/components/base/BaseTableHeaderItem.vue';

export default {
  name: 'BaseTable',
  components: {
    BaseSelect,
    BasePagen,
    EmptyList,
    BaseTableHeaderItem,
  },
  props: {
    headers: Array,
    items: Array,
    pageSize: {
      type: Number,
      default: () => 12,
    },
  },
  data() {
    return {
      sort: null,
      order: null,
      pagen: null,
    };
  },
  computed: {
    sortComputed() {
      return this.sort ?? (this.headers ?? []).find(i => !!i.sortFn && i.defaultSort);
    },
    itemsFilteredSorted() {
      return !this.sortComputed
        ? this.items
        : [...this.items].sort((a, b) => this.sortComputed.sortFn(a, b) * (this.order ? 1 : -1));
    },
    itemsToDisplay() {
      if (!this.pagen) return [];

      const { activePage, pageSize } = this.pagen;
      const start = (activePage - 1) * pageSize;
      return this.itemsFilteredSorted.slice(start, start + pageSize);
    },
    headersSplit() {
      return this.headers.map(header => ({ header, sort: this.sort === header, order: this.order }));
    },
  },
  methods: {
    sortBy(header) {
      if (this.sort === header) {
        this.order = !this.order;
      } else {
        this.sort = header;
        this.order = header.defaultOrder ?? this.order ?? true;
      }
    },
    filterBy(header, option) {
      this.$emit('filter', { header, option });
    },
    setStyle(item) {
      return (item.width) ? `min-width: ${item.width}%; width: ${item.width}%` : '';
    },
    setHeaderStyle(item) {
      return (item.header.width) ? `min-width: ${item.header.width}%; width: ${item.header.width}%` : '';
    },
  },
};
</script>

<style scoped lang="scss">

.base-table {

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .1%;
    margin-bottom: 25px;
    padding: 0 14px;
  }

  &__body {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 20px;

    & > * {
      padding: 14px;
      flex-grow: 1;
      flex-shrink: 0;

      &:nth-child(odd) {
        background: #F8F9FC;
        border-radius: 8px;
      }
    }
  }
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .1%;

    &:hover {
      background: rgba(239, 247, 255, 1);
    }
  }
}
</style>
